var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-gray-700 text-xs italic"},[_c('span',{staticClass:"text-red-700 ml-1",attrs:{"title":_vm.$t('commons.required')}},[_vm._v("*")]),_vm._v("\n    "+_vm._s(_vm.$t('commons.required'))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }